import React from "react";

const InstagramIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4.8C0 2.14903 2.14903 0 4.8 0H19.2C21.8509 0 24 2.14903 24 4.8V19.2C24 21.8509 21.8509 24 19.2 24H4.8C2.14903 24 0 21.8509 0 19.2V4.8ZM4.8 2.4C3.47452 2.4 2.4 3.47452 2.4 4.8V19.2C2.4 20.5255 3.47452 21.6 4.8 21.6H19.2C20.5255 21.6 21.6 20.5255 21.6 19.2V4.8C21.6 3.47452 20.5255 2.4 19.2 2.4H4.8ZM12 8.4C10.0117 8.4 8.4 10.0117 8.4 12C8.4 13.9883 10.0117 15.6 12 15.6C13.9883 15.6 15.6 13.9883 15.6 12C15.6 10.0117 13.9883 8.4 12 8.4ZM6 12C6 8.6863 8.6863 6 12 6C15.3137 6 18 8.6863 18 12C18 15.3137 15.3137 18 12 18C8.6863 18 6 15.3137 6 12ZM18.6 7.2C19.5941 7.2 20.4 6.39412 20.4 5.4C20.4 4.40588 19.5941 3.6 18.6 3.6C17.6059 3.6 16.8 4.40588 16.8 5.4C16.8 6.39412 17.6059 7.2 18.6 7.2Z"
        fill="#3F3F3F"
      />
    </svg>
  );
};

export default InstagramIcon;
